// 导入样式文件
import './PopUp.less';

// 导入React hooks
import { useEffect, useRef, useCallback, useContext, useState } from 'react';

// 导入自定义Icon组件
import Icon from '@/components/iconfont/Icon.jsx';

// 导入AivoiceContext
import AivoiceContext from '@/context/AiVoiceContext';
import { EditContext } from '@/context/EditContext';
// 导入创建类型图片
import CreateTypeImg from '@/assets/aivoices/popup/createtypeimg.png';
import FileInputImg from '@/assets/aivoices/popup/FileInput.png';
import StartrecordImg from '@/assets/aivoices/popup/startrecord.svg';
import StoprecordImg from '@/assets/aivoices/popup/stoprecord.svg';
import DeleteVoiceImg from '@/assets/aivoices/popup/delete-voice.png';
import { EseClosePopup } from '@/hooks/useClosePopup';
import {
  closeAudioVolumeIndicator,
  createMicrophoneStream,
  openAudioVolumeIndicator,
  stopMediaStream,
} from '@/utils/media';

import { SingleStreamRecorder } from '@/utils/recordMedia';

// 导入获取唯一麦克风列表的函数
import { getUniqueMicrophones } from '@/utils/micVoices';

// 导入上传工具类
import Uploader from '@/utils/upload';

// 导入声音控制器
import { voiceController } from '@/api/index';

import { getWaveBlob } from 'webm-to-wav-converter';

import VolumeIndicator from '@/components/volumeIndicator/VolumeIndicator.jsx';
import message from '@/utils/message';
import { useTranslation } from 'react-i18next';
// import SentryTracker from '@/utils/Sentry/sentryUtils';
// 导入文本
// import cloneText from './language';

// const languageList = [
//   {
//     id: 0,
//     name: 'English',
//   },
//   {
//     id: 1,
//     name: 'French',
//   },
//   {
//     id: 2,
//     name: 'Spanish',
//   },
//   {
//     id: 3,
//     name: 'Other',
//   },
// ];
// PopUp组件:包含多个弹窗组件
export default function PopUp() {
  return (
    <div className="PopUp_box">
      <NotificationPopUp />
      <CreateTypeModalPopUp />
      <UploadAudioModalPopUp />
      <RecordVoicesModalPopUp />
      <AudioPreviewModalPopUp />
      <ChangeVoicesNamePopUp />
      <DeleteVoicesPopUp />
    </div>
  );
}

// NotificationPopUp组件:通知弹窗
function NotificationPopUp() {
  const { t } = useTranslation();
  // 复选框状态
  const [checkboxFlag, setCheckboxFlag] = useState(false);
  // 获取当前路由路径
  const currentPath = window.location.pathname;
  const isEditRoute = currentPath.includes('/edit');
  // 声明变量但不初始化
  const aivoiceContext = useContext(AivoiceContext);
  const editContext = useContext(EditContext);

  // 根据路由选择使用哪个context的值
  const { showNotification, setShowNotification, setShowCreateTypeModal, setVoiceLanguage } =
    isEditRoute ? editContext : aivoiceContext;

  // 创建对话框的引用
  const PopUpRef = useRef(null);
  const CheckboxRef = useRef(null);

  // 处理关闭弹窗的回调函数
  const handleClose = useCallback(() => {
    console.log('弹窗已关闭');
    setShowNotification(false);
    setCheckboxFlag(false);
    CheckboxRef.current.checked = false;
  }, [setShowNotification]);

  // 处理弹窗显示和关闭事件的副作用
  useEffect(() => {
    // 如果showNotification为true，显示对话框
    if (showNotification) {
      PopUpRef.current.show();
    } else {
      PopUpRef.current.close();
    }
    const dialogElement = PopUpRef.current;
    // 如果对话框元素存在，添加关闭事件监听器
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数
    return () => {
      // 如果对话框元素存在，移除关闭事件监听器
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
  }, [handleClose, showNotification]);

  // 处理复选框变化
  const handleCheckbox = (e) => {
    setCheckboxFlag(e.target.checked);
  };

  // 处理下一步按钮点击
  const handleNext = () => {
    // console.log('下一步');
    window.onClickGATrackEvent('new-voice-next');
    setVoiceLanguage(0);
    setShowNotification(false);
    setShowCreateTypeModal(true);
  };

  return (
    <div className="notification_pop_up_box">
      <EseClosePopup close={handleClose} />
      <dialog ref={PopUpRef} className="modal">
        <div className="modal-box min-w-[720px]">
          <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 close_icon_btn">
              <Icon name="icon-close-stroke" />
            </button>
          </form>
          <div className="notification_pop_up_main">
            <div className="title">
              {/* Create New Voice */}
              {t('As_CreateVoice_P1Title')}
            </div>
            <div className="checkout_main">
              <input
                type="checkbox"
                ref={CheckboxRef}
                onChange={handleCheckbox}
                className="checkbox checkbox-primary checkbox-sm"
              />
              <div className="checkout_text">
                {/* I am aware recordings of my voice will be used by Talecast to create and use a
                synthetic version of my voice. */}
                {t('As_Clone_Disclaimer')}
              </div>
            </div>
            <button className="btn btn-primary" onClick={handleNext} disabled={!checkboxFlag}>
              {/* Next */}
              {t('As_CreateVoice_P1Button')}
            </button>
          </div>
        </div>
      </dialog>
    </div>
  );
}

// CreateTypeModalPopUp组件:创建类型模态弹窗
function CreateTypeModalPopUp() {
  const { t } = useTranslation();
  // 从AivoiceContext获取showCreateTypeModal和setShowCreateTypeModal等状态和方法
  // 获取当前路由路径
  const currentPath = window.location.pathname;
  const isEditRoute = currentPath.includes('/edit');
  // 声明变量但不初始化
  const aivoiceContext = useContext(AivoiceContext);
  const editContext = useContext(EditContext);

  // 根据路由选择使用哪个context的值
  const {
    showCreateTypeModal,
    setShowCreateTypeModal,
    newVoiceName,
    setShowUploadAudioModal,
    setNewVoiceName,
    setShowRecordAudioModal,
    // setVoiceLanguage,
    // voiceLanguage,
  } = isEditRoute ? editContext : aivoiceContext;

  // 处理声音名称变化
  const handleVoiceNameChange = (e) => {
    setNewVoiceName(e.target.value);
  };

  // 创建对话框的引用
  const PopUpRef = useRef(null);

  // 处理关闭弹窗的回调函数
  const handleClose = useCallback(() => {
    console.log('弹窗已关闭');
    setShowCreateTypeModal(false);
  }, [setShowCreateTypeModal]);

  // 处理弹窗显示和关闭事件的副作用
  useEffect(() => {
    // 如果showCreateTypeModal为true，显示对话框
    if (showCreateTypeModal) {
      PopUpRef.current.show();
    } else {
      PopUpRef.current.close();
    }
    const dialogElement = PopUpRef.current;
    // 如果对话框元素存在，添加关闭事件监听器
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数
    return () => {
      // 如果对话框元素存在，移除关闭事件监听器
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
  }, [handleClose, showCreateTypeModal]);

  // 处理打开上传模态框
  const handleOpenUpload = () => {
    // console.log(newVoiceName, 'newVoiceNamenewVoiceName');
    window.onClickGATrackEvent('new-voice-upload');
    if (!newVoiceName) return;
    setShowCreateTypeModal(false);
    setShowUploadAudioModal(true);
  };

  // 处理打开录音模态框
  const handleOpenRecord = () => {
    window.onClickGATrackEvent('new-voice-record');
    if (!newVoiceName) return;
    setShowCreateTypeModal(false);
    setShowRecordAudioModal(true);
  };
  useEffect(() => {
    console.log(newVoiceName, 'newVoiceNamenewVoiceName');
  }, [newVoiceName]);

  // const handleChangeLanguage = (e) => {
  //   setVoiceLanguage(Number(e.target.value));
  // };

  return (
    <div className="create_type_modal_pop_up_box">
      <EseClosePopup close={handleClose} />
      <dialog ref={PopUpRef} className="modal">
        <div className="modal-box min-w-[680px]">
          <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 close_icon_btn">
              <Icon name="icon-close-stroke" />
            </button>
          </form>
          <div className="create_type_modal_pop_up_main">
            <img src={CreateTypeImg} alt="" className="createtypeimg" />
            <div className="create_type_right">
              <div className="title">
                {/* Let’s create your voice clone */}
                {t('As_CreateVoice_P2Title')}
              </div>
              <div className="voicesname_ipt ">
                <span className="text">
                  {/* Voice name */}
                  {t('As_CreateVoice_VoiceName')}
                </span>
                <div className="ipt_box">
                  <input
                    type="text"
                    value={newVoiceName || ''}
                    placeholder="voices name"
                    maxLength={200}
                    onInput={handleVoiceNameChange}
                  />
                  <Icon name="icon-edit" className="popup_name_icon" />
                </div>
              </div>
              {/* <div className="voicesname_ipt ">
                <span className="text">{t('As_CreateVoice_VoiceLang')}</span>
                <select
                  className="select select-bordered w-full max-w-xs"
                  onChange={handleChangeLanguage}
                  value={voiceLanguage}>
                  {languageList.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div> */}
              <button className="btn btn-accent" onClick={handleOpenUpload}>
                <Icon name="icon-upload" className="icon" />
                {/* Upload */}
                {t('As_CreateVoice_Upload')}
              </button>
              <button
                className="btn btn-primary"
                onClick={handleOpenRecord}
                style={{ backgroundColor: '#6046FF' }}>
                <Icon name="icon-microphone" className="icon" />
                {/* Record */}
                {t('As_CreateVoice_Record')}
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
}

// UploadAudioModalPopUp组件:上传音频模态弹窗
function UploadAudioModalPopUp() {
  const { t } = useTranslation();
  // 获取当前路由路径
  const currentPath = window.location.pathname;
  const isEditRoute = currentPath.includes('/edit');
  // 声明变量但不初始化
  const aivoiceContext = useContext(AivoiceContext);
  const editContext = useContext(EditContext);

  // 根据路由选择使用哪个context的值
  const {
    showUploadAudioModal,
    setShowUploadAudioModal,
    CloseAllPupUp,
    setUpdateTimestamp,
    newVoiceName,
    // userData,
    voiceLanguage,
  } = isEditRoute ? editContext : aivoiceContext;

  // 文件数据状态
  const [fileData, setFileData] = useState(null);
  // 上传标志状态
  const [uploadFlag, setUploadFlag] = useState(false);
  // 上传进度状态
  const [progressNum, setProgressNum] = useState(0);
  // 上传文件对象状态
  const [uploadFile, setUploadFile] = useState(null);

  // 创建对话框的引用
  const PopUpRef = useRef(null);
  const UploadVoicesRef = useRef(null);

  // 处理关闭弹窗的回调函数
  const handleClose = useCallback(() => {
    console.log('弹窗已关闭');
    if (uploadFile) {
      uploadFile.stop();
    }
    setShowUploadAudioModal(false);
    UploadVoicesRef.current.value = '';
  }, [setShowUploadAudioModal, uploadFile]);

  // 处理弹窗显示和关闭事件的副作用
  useEffect(() => {
    // 如果showUploadAudioModal为true，显示对话框
    if (showUploadAudioModal) {
      PopUpRef.current.show();
    } else {
      PopUpRef.current.close();
      setProgressNum(0);
      setFileData(null);
      setUploadFlag(false);
    }
    const dialogElement = PopUpRef.current;
    // 如果对话框元素存在，添加关闭事件监听器
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数
    return () => {
      // 如果对话框元素存在，移除关闭事件监听器
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
  }, [handleClose, showUploadAudioModal, CloseAllPupUp]);

  // 上传进度回调
  const uploadCallback = (val) => {
    setProgressNum(val);
  };

  // 处理文件选择
  const handleUploadAvatar = async (event) => {
    if (!event.target.files[0]) {
      event.target.value = '';
      setFileData(null);
      return;
    }
    const file = event.target.files[0];
    const allowedExtensions = ['mp3', 'wav'];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      message.warning('Only MP3, WAV files are supported');
      event.target.value = '';
      setFileData(null);
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      message.warning('Please upload a file smaller than 5MB');
      event.target.value = '';
      setFileData(null);
      return;
    }
    console.log('文件后缀名:', fileExtension);
    // 截取文件名前200个字符
    const fileNameParts = file.name.split('.');
    const extension = fileNameParts.pop();
    const baseName = fileNameParts.join('.');
    const maxBaseLength = 200 - extension.length - 1; // -1 for the dot
    const fileName =
      baseName.length > maxBaseLength
        ? baseName.substring(0, maxBaseLength) + '.' + extension
        : file.name;
    const newfile = new File([file], fileName, { type: file.type });
    setFileData(newfile);
  };

  // 处理文件上传
  const handleUpload = async () => {
    // SentryTracker.captureEvent('voicepage_upload_click', userData?.userInfo?.email);
    window.onClickGATrackEvent('new-voice-submit');
    setUploadFlag(true);
    const fileExtension = fileData.name.split('.').pop().toLowerCase();
    try {
      const upload = new Uploader(3, uploadCallback, { ext: fileExtension });
      setUploadFile(upload);
      await upload.uploadFile(fileData);
      const res = await upload.complete();
      console.log(res);
      setUploadFile(null);
      await voiceController.add({
        name: newVoiceName,
        uploadId: res.uploadId,
        completedParts: res.eTags,
        language: voiceLanguage,
      });
      CloseAllPupUp();
      setUpdateTimestamp(new Date().getTime());
    } catch (error) {
      console.log('结束上传', error);
    }
  };

  // 处理取消上传
  const handleCancel = () => {
    handleClose();
  };

  return (
    <div className="upload_audio_modal_pop_up_box">
      <EseClosePopup close={handleClose} />
      <dialog ref={PopUpRef} className="modal">
        <div className="modal-box min-w-[520px]">
          <form method="dialog">
            <button
              data-tip="Close modal will cancel the uploading"
              className={`btn btn-sm btn-circle btn-ghost absolute right-2 top-2 close_icon_btn ${uploadFlag && 'tooltip'} tooltip-warning`}>
              <Icon name="icon-close-stroke" />
            </button>
          </form>
          <div className="upload_audio_modal_pop_up_main">
            <div className="title">
              {/* Upload */}
              {t('As_CreateVoice_Upload')}
            </div>
            <div className="upload_box">
              {fileData ? (
                <AlreadyUploaded
                  fileData={fileData}
                  uploadFlag={uploadFlag}
                  progressNum={progressNum}
                />
              ) : (
                <NotUploaded />
              )}
              <input
                onChange={handleUploadAvatar}
                type="file"
                ref={UploadVoicesRef}
                accept=".mp3,.wav"
                className="file-input file-input-bordered file-input-xs uploadinput"
              />
            </div>
            <div className="btnbox">
              {uploadFlag ? (
                <button className="btn btn-primary btn-sm uploading_btn" disabled>
                  <div className="spot_box">
                    {/* Uploading */}
                    {t('As_CreateVoice_Uploading')}
                    <span className="spot_list">
                      <span className="spot">·</span>
                      <span className="spot">·</span>
                      <span className="spot">·</span>
                    </span>
                  </div>
                </button>
              ) : (
                <>
                  <button className="btn btn-ghost btn-sm" onClick={handleCancel}>
                    {/* Cancel */}
                    {t('As_Preview_DeleteCancel')}
                  </button>
                  {fileData && (
                    <button className="btn btn-primary btn-sm" onClick={handleUpload}>
                      {/* Upload */}
                      {t('As_CreateVoice_Upload')}
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
}
// 未上传状态的组件
function NotUploaded() {
  const { t } = useTranslation();
  return (
    <div className="not_uploaded">
      <Icon name="icon-upload" className="icon" />
      <div className="upload_text">
        {/* Drop your file here, or */}
        {t('As_CreateProjectTrans_LocalDes1')}
        {/* <span>click to browse</span> */}
        {t('As_CreateProjectRewrite_LocalDes2')}
      </div>
      <div className="rules">
        {/* MP3 or WAV format. Less than 5MB. */}
        {t('As_CreateVoice_LocalDes3')}
      </div>
    </div>
  );
}

// 已上传状态的组件
function AlreadyUploaded({ fileData, uploadFlag, progressNum }) {
  const { t } = useTranslation();
  return (
    <div className="already_uploaded">
      <img src={FileInputImg} alt="" className="file_input_img" />
      <div className="file_name">{fileData?.name}</div>
      {uploadFlag ? (
        <progress className="progress progress-primary w-56" value={progressNum} max="1"></progress>
      ) : (
        <button className="btn btn-sm">
          {/* Re-upload */}
          {t('As_CreateVoice_Reupload')}
        </button>
      )}
    </div>
  );
}

// RecordVoicesModalPopUp组件:录音模态弹窗
function RecordVoicesModalPopUp() {
  const { t } = useTranslation();
  // 获取当前路由路径
  const currentPath = window.location.pathname;
  const isEditRoute = currentPath.includes('/edit');
  // 声明变量但不初始化
  const aivoiceContext = useContext(AivoiceContext);
  const editContext = useContext(EditContext);

  // 根据路由选择使用哪个context的值
  const {
    showRecordAudioModal,
    setShowRecordAudioModal,
    CloseAllPupUp,
    setShowAudioPreviewModal,
    setRecordedFile,
    // voiceLanguage,
  } = isEditRoute ? editContext : aivoiceContext;

  // 麦克风列表状态
  const [microphones, setMicrophones] = useState([]);
  // 录音状态
  const [recording, setRecording] = useState(false);
  // loading状态
  const [loading, setLoading] = useState(false);

  const [selectedMic, setSelectedMic] = useState(null);
  const [recordInstance, setRecordInstance] = useState(null);

  // 创建对话框的引用
  const PopUpRef = useRef(null);

  const audioStream = useRef(null);
  const [audioVolume, setAudioVolume] = useState(0);
  // 定义录音定时器状态
  const [recordingTimer, setRecordingTimer] = useState(0);

  const handleRecordStop = useCallback(async () => {
    if (recordingTimer < 10) {
      console.log('message提醒：录制时间必须十秒以上', recordingTimer);
      setRecording(false);
      closeAudioVolumeIndicator();
      setRecordingTimer(0); // 这里将recordingTimer重置为0
      return;
    }
    setLoading(true);
    try {
      const res = await recordInstance.stop();
      console.log(res);
      const wavBlob = await getWaveBlob(res, false);
      const file = new File([wavBlob], new Date().getTime() + '.wav', {
        type: res.type,
      });
      console.log(file, '====wavBlob1');
      setRecordedFile(file);
      handleClose();
      setShowAudioPreviewModal(true);
      setRecording(false);
    } catch (err) {
      console.error('录音处理失败:', err);
    } finally {
      setLoading(false);
      setRecordingTimer(0); // 这里将recordingTimer重置为0
      closeAudioVolumeIndicator();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordInstance, recordingTimer, setRecordedFile, setShowAudioPreviewModal]);

  // 处理关闭弹窗的回调函数·
  const handleClose = useCallback(() => {
    console.log('弹窗已关闭12312312312');
    setShowRecordAudioModal(false);
    closeAudioVolumeIndicator();
    handleRecordStop();
    if (audioStream.current) {
      stopMediaStream(audioStream.current);
      audioStream.current = null;
    }
  }, [handleRecordStop, setShowRecordAudioModal]);

  // 处理弹窗显示和关闭事件的副作用
  useEffect(() => {
    // 如果showRecordAudioModal为true，显示对话框并获取麦克风列表
    async function fetchMicrophones() {
      const res = await getUniqueMicrophones();
      setMicrophones(res.microphones || []);
      console.log('wozhixing le');
      if (!selectedMic) {
        setSelectedMic(res.microphones[0]);
      }
    }
    if (showRecordAudioModal) {
      fetchMicrophones();
      PopUpRef.current.show();
    } else {
      PopUpRef.current.close();
    }
    const dialogElement = PopUpRef.current;
    // 如果对话框元素存在，添加关闭事件监听器
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数
    return () => {
      // 如果对话框元素存在，移除关闭事件监听器
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
  }, [handleClose, showRecordAudioModal, CloseAllPupUp]);

  const handleSelectMic = (e) => {
    const selectedIndex = e.target.selectedIndex;
    console.log(microphones);

    const selectedMicrophone = microphones[selectedIndex];
    setSelectedMic(selectedMicrophone);
  };

  // 处理开始录音
  const handleRecording = async () => {
    window.onClickGATrackEvent('new-voice-start-recording');
    try {
      const stream = await createMicrophoneStream(selectedMic.deviceId);
      audioStream.current = stream;
      openAudioVolumeIndicator(stream, setAudioVolume);
      const instance = new SingleStreamRecorder(stream);
      setRecordInstance(instance);
      instance.start();
      setRecording(true);
    } catch (error) {
      console.log(error, '开始录制失败');
      message.info('Please check your microphone availability');
    }
  };

  // 处理录音计时
  useEffect(() => {
    let timer;
    if (recording) {
      timer = setInterval(() => {
        setRecordingTimer((prevTimer) => prevTimer + 1);
      }, 1000);
    } else {
      clearInterval(timer);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [recording]);

  // 格式化录音时间
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    if (recordingTimer >= 60) {
      handleRecordStop();
    }
  }, [recordingTimer, handleRecordStop]);

  return (
    <div className="record_voices_modal_pop_up_box">
      <EseClosePopup close={handleClose} />
      <dialog ref={PopUpRef} className="modal">
        <div className="modal-box min-w-[720px]">
          <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 close_icon_btn">
              <Icon name="icon-close-stroke" />
            </button>
          </form>
          <div
            className={`record_voices_modal_pop_up_main ${recording ? 'record_voices_modal_pop_up_recording' : ''}`}>
            <div className="title">
              {/* Record to clone voice */}
              {t('As_CreateVoice_P3Title')}
            </div>
            <div className="secondary_title">
              {/* Please record the statement below to train your speaker and authorize its use.
              <br /> For the best results, read with range in your voice and tone, more than 10
              seconds. */}
              {t('As_CreateVoice_P3Des')}
            </div>
            {/* {(voiceLanguage === 0 || voiceLanguage === 3) && (
              <div className="read_text">{cloneText.English}</div>
            )}
            {voiceLanguage === 1 && <div className="read_text">{cloneText.French}</div>}
            {voiceLanguage === 2 && <div className="read_text">{cloneText.Spanish}</div>} */}
            <div className="read_text">{t('As_Clone_Reading')}</div>

            <div className="option_box">
              <div className="mic_box">
                <div className="mic_text">
                  {/* Microphone： */}
                  {t('As_CreateVoice_P3Microphone')}
                </div>
                <select
                  className="select select-bordered w-full mic_select"
                  disabled={recording || loading}
                  onChange={handleSelectMic}
                  value={selectedMic ? JSON.stringify(selectedMic) : ''}>
                  {microphones.length <= 0 && <option disabled>No devices</option>}
                  {microphones.map((item, index) => (
                    <option key={index} value={JSON.stringify(item)}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              {recording ? (
                <button
                  className="btn btn-ghost"
                  onClick={handleRecordStop}
                  disabled={loading || (recordingTimer < 10 ? true : false)}>
                  {loading ? (
                    <span className="loading loading-spinner loading-sm"></span>
                  ) : (
                    <img src={StoprecordImg} alt="" />
                  )}
                  {/* Stop */}
                  {t('As_CreateVoice_Stop')}
                </button>
              ) : (
                <button className="btn btn-error" onClick={handleRecording} disabled={loading}>
                  <img src={StartrecordImg} alt="" />
                  {/* Start Recording */}
                  {t('As_CreateVoice_StartRecording')}
                </button>
              )}
            </div>
            {recording && (
              <>
                <div className="mic_vloume">
                  <VolumeIndicator volume={audioVolume} type="ai"></VolumeIndicator>
                </div>
                <div className="recording_time">
                  {formatTime(recordingTimer)}
                  <span>/ 01:00</span>
                </div>
              </>
            )}
          </div>
        </div>
      </dialog>
    </div>
  );
}

// AudioPreviewModalPopUp组件: 音频预览模态弹窗
function AudioPreviewModalPopUp() {
  const { t } = useTranslation();
  // 获取当前路由路径
  const currentPath = window.location.pathname;
  const isEditRoute = currentPath.includes('/edit');
  // 声明变量但不初始化
  const aivoiceContext = useContext(AivoiceContext);
  const editContext = useContext(EditContext);

  // 根据路由选择使用哪个context的值
  const {
    showAudioPreviewModal, // 控制预览模态框显示状态
    setShowAudioPreviewModal, // 设置预览模态框显示状态
    setShowRecordAudioModal, // 设置录音模态框显示状态
    recordedFile, // 录制的音频文件
    newVoiceName, // 新语音名称
    CloseAllPupUp,
    setUpdateTimestamp,
    // userData,
    voiceLanguage,
  } = isEditRoute ? editContext : aivoiceContext;
  // 音频播放相关状态
  const [isPlaying, setIsPlaying] = useState(false); // 是否正在播放
  const [progress, setProgress] = useState(0); // 播放进度(0-100)
  const [audio] = useState(new Audio()); // 音频实例
  const [duration, setDuration] = useState(0); // 音频总时长(秒)
  const [currentTime, setCurrentTime] = useState(0); // 当前播放时间(秒)
  const [loading, setLoading] = useState(false); // 添加loading状态

  // 初始化音频:设置音频源和事件监听
  useEffect(() => {
    if (recordedFile) {
      const url = URL.createObjectURL(recordedFile);
      audio.src = url;

      // 添加错误处理
      const handleError = (e) => {
        console.log('音频加载错误:', e);
        // message.error('音频加载失败,请重试');
      };

      // 添加canplay事件监听
      const handleCanPlay = () => {
        // 某些浏览器可能需要在canplay后才能获取正确的duration
        setDuration(audio.duration);
      };

      audio.addEventListener('error', handleError);
      audio.addEventListener('canplay', handleCanPlay);
      audio.addEventListener('loadedmetadata', () => {
        setDuration(audio.duration || 0); // 添加默认值
      });

      audio.addEventListener('timeupdate', () => {
        if (audio.duration) {
          // 添加duration检查
          setCurrentTime(audio.currentTime);
          setProgress((audio.currentTime / audio.duration) * 100);
        }
      });

      audio.addEventListener('ended', () => {
        setIsPlaying(false);
        setProgress(0);
        setCurrentTime(0);
      });

      // 尝试加载音频
      audio.load();

      return () => {
        URL.revokeObjectURL(url);
        audio.removeEventListener('error', handleError);
        audio.removeEventListener('canplay', handleCanPlay);
        audio.removeEventListener('loadedmetadata', () => {});
        audio.removeEventListener('timeupdate', () => {});
        audio.removeEventListener('ended', () => {});
        audio.src = ''; // 清除音频源
      };
    }
  }, [audio, recordedFile]);

  // 处理播放/暂停切换
  const handlePlayPause = () => {
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  // 处理进度条点击,更新播放进度
  const handleProgressChange = (e) => {
    audio.pause();
    setIsPlaying(false);
    const progressBar = document.getElementById('playProgressid');
    const rect = progressBar.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percent = (x / rect.width) * 100;
    const newTime = (percent / 100) * duration;

    audio.currentTime = newTime;
    setProgress(percent);
    setCurrentTime(newTime);
  };

  // 处理进度条拖拽
  const handleMouseChangeProgress = (e) => {
    if (isPlaying) {
      handlePlayPause();
    }
    const handleMouseMove = (e) => handleProgressChange(e);
    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    handleProgressChange(e);
  };

  // 格式化时间显示为 MM:SS 格式
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  // 创建对话框引用
  const PopUpRef = useRef(null);

  // 处理关闭弹窗
  const handleClose = useCallback(() => {
    audio.pause();
    setIsPlaying(false);
    audio.currentTime = 0;
    setProgress(0);
    setCurrentTime(0);
    setShowAudioPreviewModal(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audio, showAudioPreviewModal]);

  // 处理弹窗显示和关闭事件
  useEffect(() => {
    setIsPlaying(false);
    setProgress(0);
    setCurrentTime(0);
    // 根据showAudioPreviewModal状态显示/关闭对话框
    if (showAudioPreviewModal) {
      console.log('打开了');
      PopUpRef.current.show();
    } else {
      audio.pause();
      PopUpRef.current.close();
    }
    const dialogElement = PopUpRef.current;

    // 添加关闭事件监听
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数:移除事件监听
    return () => {
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleClose, showAudioPreviewModal]);

  // 处理重新录制
  const handleReRecord = () => {
    setShowAudioPreviewModal(false);
    setShowRecordAudioModal(true);
  };

  // 处理上传提交
  const handleUploadSubmit = async () => {
    // SentryTracker.captureEvent('voicepage_submit_click', userData?.userInfo?.email);
    window.onClickGATrackEvent('new-voice-submit');
    setLoading(true);
    const fileExtension = recordedFile.name.split('.').pop().toLowerCase();
    try {
      // 创建上传实例并上传文件
      const upload = new Uploader(3, uploadCallback, { ext: fileExtension });
      await upload.uploadFile(recordedFile);
      const res = await upload.complete();
      // 添加语音记录
      await voiceController.add({
        name: newVoiceName,
        uploadId: res.uploadId,
        completedParts: res.eTags,
        language: voiceLanguage,
      });
      CloseAllPupUp();
      setUpdateTimestamp(new Date().getTime());
    } catch (error) {
      console.log('上传失败', error);
    } finally {
      setLoading(false);
    }
  };

  // 上传进度回调
  const uploadCallback = (val) => {
    console.log('上传进度:', val);
  };

  return (
    <div className="audio_preview_modal_pop_up_box">
      <EseClosePopup close={handleClose} />
      <dialog ref={PopUpRef} className="modal">
        <div className="modal-box min-w-[720px]">
          <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 close_icon_btn">
              <Icon name="icon-close-stroke" />
            </button>
          </form>
          <div className="audio_preview_modal_pop_up_main">
            <div className="title">
              {/* Record to clone voice */}
              {t('As_CreateVoice_P3Title')}
            </div>
            <div className="play_voices_box">
              <div className="play_icon_box" onClick={handlePlayPause}>
                {isPlaying ? (
                  <Icon name="icon-pause-rounded" className="play_icon" />
                ) : (
                  <Icon name="icon-play" className="play_icon" />
                )}
              </div>
              <div
                className="play_progress"
                id="playProgressid"
                onMouseDown={(e) => {
                  handleMouseChangeProgress(e);
                }}>
                <div className="progress_num" style={{ width: `${progress}%` }}></div>
              </div>
              <div className="play_time">
                {formatTime(currentTime)} / {formatTime(duration)}
              </div>
            </div>

            <div className="option_btn">
              <button className="btn re_record_btn" onClick={handleReRecord}>
                {/* Re-record */}
                {t('As_CreateVoice_P4Back')}
              </button>
              <button
                className="btn btn-primary clone_btn"
                onClick={handleUploadSubmit}
                disabled={loading}>
                {loading && <span className="loading loading-spinner loading-sm"></span>}
                {/* Submit & clone */}
                {t('As_Remind_LocalDes4')}
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
}

// ChangeVoicesNamePopUp组件:修改声音名称弹窗
function ChangeVoicesNamePopUp() {
  const { t } = useTranslation();
  // 获取当前路由路径
  const currentPath = window.location.pathname;
  const isEditRoute = currentPath.includes('/edit');
  // 声明变量但不初始化
  const aivoiceContext = useContext(AivoiceContext);
  const editContext = useContext(EditContext);

  // 根据路由选择使用哪个context的值
  const {
    showChangeNameModal,
    setShowChangeNameModal,
    currentItem,
    setUpdateTimestamp,
    setCurrentItem,
    setIsInputFocused,
    setSpeakerList,
    selectSpeakerItem,
    setSelectSpeakerItem,
    selectVoiceItem,
    setSelectVoiceItem,
  } = isEditRoute ? editContext : aivoiceContext;

  // 创建对话框的引用
  const PopUpRef = useRef(null);
  // 修改后的名字状态
  const [newName, setNewName] = useState('');

  // 处理输入变化
  const handleInputChange = (e) => {
    setNewName(e.target.value);
  };

  // 处理关闭弹窗的回调函数
  const handleClose = useCallback(() => {
    console.log('弹窗已关闭');
    setShowChangeNameModal(false);
  }, [setShowChangeNameModal]);

  // 处理弹窗显示和关闭事件的副作用
  useEffect(() => {
    // 如果showChangeNameModal为true，显示对话框
    if (showChangeNameModal) {
      PopUpRef.current.show();
      setNewName(currentItem.name);
    } else {
      PopUpRef.current.close();
    }
    const dialogElement = PopUpRef.current;
    // 如果对话框元素存在，添加关闭事件监听器
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数
    return () => {
      // 如果对话框元素存在，移除关闭事件监听器
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
  }, [handleClose, showChangeNameModal, currentItem]);

  // 处理编辑名称提交
  const handleEditNameSubmit = async () => {
    try {
      console.log(newName);
      if (!newName) return;
      if (newName === currentItem.name) {
        handleClose();
        return;
      }
      await voiceController.rename({
        voiceNum: currentItem.number,
        body: {
          newName: newName,
        },
      });
      setCurrentItem((prev) => ({
        ...prev,
        name: newName,
      }));
      console.log(currentItem, 'currentItem');
      if (isEditRoute) {
        if (selectSpeakerItem.voiceNumber === currentItem.number) {
          setSelectSpeakerItem((prevList) => ({
            ...prevList,
            voiceName: newName,
          }));
        }
        console.log(selectVoiceItem, 'sdffdsfdsf');
        if (selectVoiceItem.number === currentItem.number) {
          setSelectVoiceItem((prevList) => ({
            ...prevList,
            name: newName,
          }));
        }

        setSpeakerList((prevList) =>
          prevList.map((speaker) =>
            speaker.voiceNumber === currentItem.number
              ? { ...speaker, voiceName: newName }
              : speaker,
          ),
        );
      }

      setTimeout(() => {
        setUpdateTimestamp(new Date().getTime());
        handleClose();
      }, 10);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      message.error(t('As_Edit_RenameDisabled'));
    }
  };

  return (
    <div className="change_voices_name_pop_up_box">
      <EseClosePopup close={handleClose} />
      <dialog ref={PopUpRef} className="modal">
        <div className="modal-box min-w-[480px]">
          <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 close_icon_btn">
              <Icon name="icon-close-stroke" />
            </button>
          </form>
          <div className="change_voices_name_pop_up_main">
            <div className="title">
              {/* Rename voice */}
              {t('As_VoiceManage_PopUpRename')}
            </div>
            <input
              type="text"
              placeholder=""
              onChange={handleInputChange}
              maxLength={200}
              onFocus={() => {
                if (setIsInputFocused) {
                  setIsInputFocused(true);
                }
              }}
              onBlur={() => {
                if (setIsInputFocused) {
                  setIsInputFocused(false);
                }
              }}
              value={newName}
              className="input input-bordered w-full name_ipt"
            />
            <div className="btn_box">
              <button className="btn btn-outline btn_cancel" onClick={handleClose}>
                {/* Cancel */}
                {t('As_CreateProjectTrans_PopUpCancel')}
              </button>
              <button className="btn btn-primary btn_ok" onClick={handleEditNameSubmit}>
                {/* OK */}
                {t('As_VoiceManage_PopUpRenameCancel')}
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
}

// DeleteVoicesPopUp组件:删除声音弹窗
function DeleteVoicesPopUp() {
  const { t } = useTranslation();
  // 获取当前路由路径
  const currentPath = window.location.pathname;
  const isEditRoute = currentPath.includes('/edit');
  // 声明变量但不初始化
  const aivoiceContext = useContext(AivoiceContext);
  const editContext = useContext(EditContext);

  // 根据路由选择使用哪个context的值
  const { showDeleteModal, setShowDeleteModal, currentItem, setVoiceDeleteTime } = isEditRoute
    ? editContext
    : aivoiceContext;

  // 创建对话框的引用
  const PopUpRef = useRef(null);

  // 处理关闭弹窗的回调函数
  const handleClose = useCallback(() => {
    console.log('弹窗已关闭');
    setShowDeleteModal(false);
  }, [setShowDeleteModal]);

  // 处理弹窗显示和关闭事件的副作用
  useEffect(() => {
    // 如果showDeleteModal为true，显示对话框
    if (showDeleteModal) {
      PopUpRef.current.show();
    } else {
      PopUpRef.current.close();
    }
    const dialogElement = PopUpRef.current;
    // 如果对话框元素存在，添加关闭事件监听器
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数
    return () => {
      // 如果对话框元素存在，移除关闭事件监听器
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
  }, [handleClose, showDeleteModal]);
  const handleDelete = async () => {
    await voiceController.delete({
      voiceNum: currentItem.number,
    });
    setVoiceDeleteTime(new Date().getTime());

    handleClose();
  };
  return (
    <div className="delete_voices_pop_up_box">
      <EseClosePopup close={handleClose} />
      <dialog ref={PopUpRef} className="modal">
        <div className="modal-box min-w-[400px]">
          <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 close_icon_btn">
              <Icon name="icon-close-stroke" />
            </button>
          </form>
          <div className="delete_voices_pop_up_main">
            <img src={DeleteVoiceImg} alt="" className="delete_img" />
            <div className="title">
              {/* Deleted voice cannot be restored */}
              {t('As_VoiceManage_PopUpDelete')}
            </div>
            <button className="btn btn-error btn-sm delete_btn" onClick={handleDelete}>
              {/* Delete */}
              {t('As_Preview_PreviewDelete')}
            </button>
            <button className="btn btn-ghost btn-sm cancel_btn" onClick={handleClose}>
              {/* Cancel */}
              {t('As_VoiceManage_PopUpRenameConfirm')}
            </button>
          </div>
        </div>
      </dialog>
    </div>
  );
}
